// extracted by mini-css-extract-plugin
module.exports = {"cylinderWrapper":"CylinderIcons_cylinderWrapper__uwmcv"};